import React, { useState, useEffect, Suspense } from "react";
// import { withRouter } from "react-router-dom";
import Routes from "./Routes";
import { BeatLoader } from 'react-spinners';
import { BrowserRouter } from 'react-router-dom';
import "./App.css";
import { Auth } from "aws-amplify";
import "./modules/users/login/SignIn.css";
import "./modules/users/login/SignInResponsive.css";
import "../src/modules/menu/Menu.css";
import { createTheme, ThemeProvider } from "@material-ui/core/styles";
import CssBaseline from "@material-ui/core/CssBaseline";
import { esES } from '@material-ui/core/locale';

const theme = createTheme({
  typography: {
    htmlFontSize: 10
  },
  overrides: {
    MuiCssBaseline: {
      "@global": {
        html: { fontSize: "62.5%" }
      }
    }
  }
}, esES);

const spinnerCss = {
  position: 'fixed',
  top: '50%',
  left: '50%',
  marginLeft: '-30px'
};

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const checkAuth = async () => {
      try {
        await Auth.currentSession();
        setIsAuthenticated(true);
      } catch (e) {
        setIsAuthenticated(false);
      } finally {
        setIsLoading(false);
      }
    };
    checkAuth();
  }, []);

  if (isLoading) {
    return <BeatLoader css={spinnerCss} size={15} margin={4} color={"#bf2349"} />;
  }

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <div id="wrapper" className="wrapper" style={{ height: "100%", width: "100%" }}>
        <Suspense fallback={<BeatLoader css={spinnerCss} size={15} margin={4} color={"#bf2349"} />}>
          <Routes appProps={{ isAuthenticated, userHasAuthenticated: setIsAuthenticated, logout: false }} />
        </Suspense>
      </div>
    </ThemeProvider>
  );
}

export default App;
